import { Component, OnInit, ViewChild } from '@angular/core';
import { IMessage } from 'src/app/shared/interfaces/message';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.css'
})
export class MessageComponent implements OnInit {

  @ViewChild('modal') modal!: ModalComponent;

  messagesList: IMessage[];
  showMessage: IMessage;

  messageStatus = [
    {title:'خوانده شده' , value:2},
    {title:'خوانده نشده' , value:1},
  ]

  constructor(private fakeDataService: FakeDataService,
    private apiService: ApiService
  ){}


  ngOnInit(): void {
    this.getMessages();
  }

  getMessages() {
    // this.fakeDataService.getMessages().subscribe((res: IMessage[]) => {
    //   this.messagesList = res;
    // })

    this.apiService.apiCall('get', '/api/User/GetAllUserMessage').subscribe((res: any) => {
      console.log(res);
      
      this.messagesList = res.body.model;
    })
  }

  seeMessage(msgId) {
    this.apiService.apiCall('post', '/api/User/SeeMessage/'+msgId).subscribe((res: any) => {
      console.log(res);
      
    })
  }


}
